import { supabase } from '../../lib/supabase';

// Reads every row of a table page by page (the server returns at most 1000 rows per request).
export async function pageAllRows(table, cols, mod, orderCol) {
  let all = [], from = 0;
  for (;;) {
    let qq = supabase.from(table).select(cols);
    if (mod) qq = mod(qq);
    qq = qq.order(orderCol || 'id');   // a stable order, so pages never overlap or skip rows
    const { data, error } = await qq.range(from, from + 999);
    if (error) throw error;
    all = all.concat(data || []);
    if (!data || data.length < 1000) break;
    from += 1000;
  }
  return all;
}
// same result shape as a normal query ({ data, error }), but returns every row however many there are
export async function allRows(table, cols, mod, orderCol) {
  try { return { data: await pageAllRows(table, cols, mod, orderCol), error: null }; }
  catch (e) { return { data: null, error: e }; }
}
